export default {
    data() {
        return {
            sign_doctor_list:[],
            operation_place_list:[],
            operation_doctor_list:[],
            assistant1_list:[],
            assistant2_list:[],
            operation_fee_list:[],
            operation_name_list:[],
            operation_date_list:[],
            operation_note_list:[],
        }
    },
    created () {
        this.fillLocal();
        
    },
    methods: {
        updateLocal(type){
            if (type === 0) {
                this.sign_doctor_list = []
                this.getLocalList(this.sign_doctor_list, "sign_doctor_list");
            }else if (type === 1){
                this.operation_place_list = []
                this.getLocalList(this.operation_place_list, "operation_place_list");
            }else if (type === 2){
                this.operation_doctor_list = []
                this.getLocalList(this.operation_doctor_list, "operation_doctor_list");
            }else if (type === 3){
                this.assistant1_list = []
                this.getLocalList(this.assistant1_list, "assistant1_list");
            }else if (type === 4){
                this.assistant2_list = []
                this.getLocalList(this.assistant2_list, "assistant2_list");
            }else if (type === 5){
                this.operation_fee_list = []
                this.getLocalList(this.operation_fee_list, "operation_fee_list");
            }else if (type === 6){
                this.operation_name_list = []
                this.getLocalList(this.operation_name_list, "operation_name_list");
            }else if (type === 7){
                this.operation_date_list = []
                this.getLocalList(this.operation_date_list, "operation_date_list");
            }else if (type === 8){
                this.operation_note_list = []
                this.getLocalList(this.operation_note_list, "operation_note_list");
            }
        },
        fillLocal(){
          this.appointment.sign_doctor = this.getLastLocalListVal("sign_doctor_list");
          this.appointment.operation_place = this.getLastLocalListVal("operation_place_list");
          // this.appointment.operation_doctor = this.getLastLocalListVal("operation_doctor_list");
          // this.appointment.assistant1 = this.getLastLocalListVal("assistant1_list");
          // this.appointment.assistant2 = this.getLastLocalListVal("assistant2_list");
          // this.appointment.operation_fee = this.getLastLocalListVal("operation_fee_list");
          this.appointment.operation_name = this.getLastLocalListVal("operation_name_list");
          this.appointment.operation_date = this.getLastLocalListVal("operation_date_list");
        },
        signdoctorlist(mainSuggesionString, cb) {
          let results = this.sign_doctor_list;
          // 调用 callback 返回建议列表的数据
          cb(results);
        },
        operationplacelist(mainSuggesionString, cb) {
          let results = this.operation_place_list;
          // 调用 callback 返回建议列表的数据
          cb(results);
        },
        operationdoctorlist(mainSuggesionString, cb) {
          let results = this.operation_doctor_list;
          // 调用 callback 返回建议列表的数据
          cb(results);
        },
        assistant1list(mainSuggesionString, cb) {
          let results = this.assistant1_list;
          // 调用 callback 返回建议列表的数据
          cb(results);
        },
        assistant2list(mainSuggesionString, cb) {
          let results = this.assistant2_list;
          // 调用 callback 返回建议列表的数据
          cb(results);
        },
        operationfeelist(mainSuggesionString, cb) {
          let results = this.operation_fee_list;
          // 调用 callback 返回建议列表的数据
          cb(results);
        },
        operationnamelist(mainSuggesionString, cb) {
          let results = this.operation_name_list;
          // 调用 callback 返回建议列表的数据
          cb(results);
        },
        operationnotelist(mainSuggesionString, cb) {
          let results = this.operation_note_list;
          // 调用 callback 返回建议列表的数据
          cb(results);
        },

        getLastLocalListVal(localName) {
          // thisData =[]
          let DoctorList = localStorage.getItem(localName);
          if (DoctorList) {
            let data = JSON.parse(DoctorList);
            return data[0]
          }else{
              return ''
          }
        },
        getLocalList(thisData, localName) {
          // thisData =[]
          let DoctorList = localStorage.getItem(localName);
          if (DoctorList) {
            let data = JSON.parse(DoctorList);
            for (const item of data) {
              thisData.push({ value: item });
            }
          }
        },
        saveSuggesion(type) {
          if (type === 0) {
            this.saveLocalList(
              this.appointment.sign_doctor,
              "sign_doctor_list"
            );
          } else if (type === 1) {
            this.saveLocalList(
              this.appointment.operation_place,
              "operation_place_list"
            );
          }else if (type === 2) {
              this.saveLocalList(
                this.appointment.operation_doctor,
                "operation_doctor_list"
              );
          }else if (type === 3) {
              this.saveLocalList(
                this.appointment.assistant1,
                "assistant1_list"
              );
          }else if (type === 4) {
              this.saveLocalList(
                this.appointment.assistant2,
                "assistant2_list"
              );
          }else if (type === 5) {
              this.saveLocalList(
                this.appointment.operation_fee,
                "operation_fee_list"
              );
          }else if (type === 6) {
              this.saveLocalList(
                this.appointment.operation_name,
                "operation_name_list"
              );
          }else if (type === 7) {
              this.saveLocalList(
                this.appointment.operation_date,
                "operation_date_list"
              );
          }else if (type === 8) {
              this.saveLocalList(
                this.appointment.note,
                "operation_note_list"
              );
          }
        },
        saveLocalList(thisData, localName) {
          if (thisData) {
            let mainDoctorList = localStorage.getItem(localName);
            if (mainDoctorList) {
              let data = JSON.parse(mainDoctorList);
              data.unshift(thisData);
              let NewData = _.chunk(_.uniq(data), 5)[0];
              localStorage.setItem(localName, JSON.stringify(NewData));
            } else {
              let data = [];
              data.unshift(thisData);
              localStorage.setItem(localName, JSON.stringify(data));
            }
          }
        }
    },
}